export const auth = () => ({
    passwordReset: () => `/password_reset`,
    magicLink: () => `/auth/magic_link`,
    login: () => `/auth/token`,
    refresh: () => `/auth/token/refresh`,
    login2FA: () => `/auth/2fa`,
    // walletLogin: () => '/auth/wallet/login',
    getDiscordAuthorizationUrl: () => '/oauth/discord/authorize',
    discordLogin: () => '/oauth/discord/login',
    getTwitterAuthorizationUrl: () => '/oauth/twitter/authorize',
    twitterLogin: () => '/oauth/twitter/login',
    twitterToken: () => '/oauth/twitter/token',
    twitterDeLink: () => '/oauth/twitter/delink',
});
